import React from "react";

import { InfoIcon } from "lucide-react";

import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

interface ProductFormProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
  unitPrice: number | null;
  setUnitPrice: (price: number) => void;
  discountPercent: number;
  suggestedPrice?: number;
  warningThresholdPrice?: number;
}

const ProductForm: React.FC<ProductFormProps> = ({
  quantity,
  setQuantity,
  unitPrice,
  setUnitPrice,
  discountPercent,
  suggestedPrice,
  warningThresholdPrice,
}) => {
  const isPriceBelowSuggested =
    warningThresholdPrice !== undefined &&
    unitPrice !== null &&
    unitPrice <= warningThresholdPrice;

  return (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Label htmlFor="quantity-input" className="mb-1 block">
          Cantidad
        </Label>
        <Input
          id="quantity-input"
          type="number"
          inputMode="numeric"
          min="1"
          step="1"
          value={quantity}
          onChange={(e) => {
            const val = parseInt(e.target.value, 10);
            setQuantity(isNaN(val) ? 1 : val);
          }}
          onFocus={(e) => {
            e.target.select();
          }}
          onKeyDown={(e) => {
            if (e.key === "," || e.key === ".") {
              e.preventDefault();
            }
          }}
        />
      </div>
      <div>
        <Label htmlFor="price-input" className="mb-1 block">
          Precio Unitario
        </Label>
        <Input
          id="price-input"
          type="number"
          inputMode="numeric"
          step="1"
          min="0"
          value={unitPrice ?? ""}
          onChange={(e) => setUnitPrice(parseFloat(e.target.value) || 0)}
          onFocus={(e) => {
            e.target.select();
          }}
          onKeyDown={(e) => {
            if (e.key === "," || e.key === ".") {
              e.preventDefault();
            }
          }}
        />
        {suggestedPrice !== undefined && (
          <div className="pt-1 text-xs text-muted-foreground">
            Precio sugerido:{" "}
            {suggestedPrice.toLocaleString("es-CL", {
              style: "currency",
              currency: "CLP",
            })}
          </div>
        )}
        {isPriceBelowSuggested && (
          <div className="flex items-center pt-1 text-xs text-amber-600">
            <InfoIcon className="mr-1 h-3 w-3" />
            Precio por debajo del sugerido. La orden requerirá aprobación.
          </div>
        )}
      </div>
      <div>
        <Label className="mb-1 block">Dcto. %</Label>
        <div className="flex h-10 items-center rounded-md border bg-muted px-3 text-sm text-muted-foreground">
          {discountPercent > 0 ? `${discountPercent}%` : "-"}
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
